import {
  ARTICLE_LISTE_SUCCES,
  ARTICLE_LISTE_ECHEC,
  ARTICLE_LISTE_REQUETTE,
  ARTICLE_FAMILLE_SUCCES,
  ARTICLE_FAMILLE_ECHEC,
  ARTICLE_FAMILLE_RESET,
  ARTICLE_FAMILLE_REQUETTE,
  ARTICLE_DETAILS_SUCCES,
  ARTICLE_DETAILS_ECHEC,
  ARTICLE_DETAILS_REQUETTE,
  ARTICLE_TOUT_SUCCES,
  ARTICLE_TOUT_ECHEC,
  ARTICLE_TOUT_RESET,
  EVALUATION_REQUETTE,
  EVALUATION_SUCCES,
  EVALUATION_ECHEC,
  ARTICLE_MARQUE_ECHEC,
  ARTICLE_MARQUE_SUCCES,
  ARTICLE_LISTE_ALL_ECHEC,
  ARTICLE_LISTE_ALL_SUCCES,
  ARTICLE_NV_CREE_REQUETTE,
  ARTICLE_NV_CREE_SUCCES,
  ARTICLE_NV_CREE_ECHEC,
  ARTICLE_LISTE_PROMO_ECHEC,
  ARTICLE_LISTE_PROMO_SUCCES,
  ARTICLE_LISTE_PROMO_REQUETTE,
} from "../constantes/articlesConstantes";
import Axios from "axios";

//const uri = `http://192.168.1.21:5000`;

//const uri = `https://ahmed.prod-manager.tk/back`;
//const uri = `https://gestpro.globalsystempro.com/back_2`;

import { store } from "../store";
let uri = "";
function changeURi() {
  const cliServ = store.getState().cliServState.cliServ;
  return (uri =
    cliServ != 0
      ? cliServ == "SERV1"
        ? process.env.REACT_APP_SERV_1
        : process.env.REACT_APP_SERV_2
      : process.env.REACT_APP_SERV_1);
}
changeURi();
export const listeArticles = () => async (dispatch, getState) => {
  try {
    dispatch({ type: ARTICLE_LISTE_REQUETTE });
    const {
      client: { client },
    } = getState();
    const { data } = await Axios.get(`${uri}/api/articles`);
    let fautFiltre = client.activites != "T" && client.activites;
    if (fautFiltre) {
      console.log(
        "ce utilisateur a activité de " +
          client.activites +
          " donc il faut faire le filtrage selon ce critére!"
      );
      let datafilter = data.filter((art) =>
        art.activites.some((activity) => activity.code_act === client.activites)
      );
      dispatch({ type: ARTICLE_LISTE_SUCCES, payload: datafilter });
    } else {
      console.log("Pas de filtrage nécessaire");
      dispatch({ type: ARTICLE_LISTE_SUCCES, payload: data });
    }
  } catch (error) {
    dispatch({ type: ARTICLE_LISTE_ECHEC, payload: error });
  }
};
export const listeArticlesPromo = () => async (dispatch) => {
  try {
    dispatch({ type: ARTICLE_LISTE_PROMO_REQUETTE });
    const { data } = await Axios.get(`${uri}/api/articles/promo`);

    dispatch({ type: ARTICLE_LISTE_PROMO_SUCCES, payload: data });
  } catch (error) {
    dispatch({ type: ARTICLE_LISTE_PROMO_ECHEC, payload: error });
  }
};

export const listeArticlesAll = () => async (dispatch) => {
  try {
    const { data } = await Axios.get(`${uri}/api/articles/all`);
    //https://gestpro.globalsystempro.com/back/api/articles/all

    dispatch({ type: ARTICLE_LISTE_ALL_SUCCES, payload: data });
  } catch (error) {
    dispatch({ type: ARTICLE_LISTE_ALL_ECHEC, payload: error });
  }
};
//Later
export const listeArticlesParFamille = (itemId) => async (dispatch) => {
  try {
    dispatch({ type: ARTICLE_FAMILLE_RESET });
    dispatch({ type: ARTICLE_FAMILLE_REQUETTE });
    const { data } = await Axios.get(`${uri}/api/articles/famille/${itemId}`);
    dispatch({ type: ARTICLE_FAMILLE_SUCCES, payload: data });
  } catch (error) {
    dispatch({ type: ARTICLE_FAMILLE_ECHEC, payload: error });
  }
};
export const listeArticlesParFamilleLoc =
  (itemId, chaine) => async (dispatch) => {
    try {
      dispatch({ type: ARTICLE_FAMILLE_RESET });
      dispatch({ type: ARTICLE_FAMILLE_REQUETTE });
      const { data } = await Axios.get(
        `http://${chaine.host}:5000/api/oracle/article/${chaine.host}/${chaine.database}/${chaine.user}/${chaine.pwd}/${itemId}`
      );
      dispatch({ type: ARTICLE_FAMILLE_SUCCES, payload: data });
    } catch (error) {
      dispatch({ type: ARTICLE_FAMILLE_ECHEC, payload: error });
    }
  };
export const listeAllArticlesParFamille = (itemId) => async (dispatch) => {
  try {
    dispatch({ type: ARTICLE_FAMILLE_RESET });
    dispatch({ type: ARTICLE_FAMILLE_REQUETTE });
    const { data } = await Axios.get(
      `${uri}/api/articles/familleall/${itemId}`
    );
    dispatch({ type: ARTICLE_FAMILLE_SUCCES, payload: data });
  } catch (error) {
    dispatch({ type: ARTICLE_FAMILLE_ECHEC, payload: error });
  }
};
export const listeAllArticlesParFamilleLoc = (itemId) => async (dispatch) => {
  try {
    dispatch({ type: ARTICLE_FAMILLE_RESET });
    dispatch({ type: ARTICLE_FAMILLE_REQUETTE });
    const { data } = await Axios.get(
      `${uri}/api/articles/familleall/${itemId}`
    );
    dispatch({ type: ARTICLE_FAMILLE_SUCCES, payload: data });
  } catch (error) {
    dispatch({ type: ARTICLE_FAMILLE_ECHEC, payload: error });
  }
};
export const rechArticle = (rech, crit, artTab) => (dispatch) => {
  let tab = [];

  if (crit == "fam") {
    tab = artTab.map((cli) => {
      if (cli?.nom?.toUpperCase().includes(rech.toUpperCase())) {
        tab.push([...tab, cli]);
      }
    });

    dispatch({ type: ARTICLE_FAMILLE_SUCCES, payload: tab });
  } else {
    tab = artTab.map((cli) => {
      if (cli?.nom?.toUpperCase().includes(rech.toUpperCase())) {
        tab.push([...tab, cli]);
      }
    });
    dispatch({ type: ARTICLE_LISTE_SUCCES, payload: tab });
  }
};

export const listeArticlesParMarque = (itemId) => async (dispatch) => {
  try {
    const { data } = await Axios.get(`${uri}/api/articles/marque/${itemId}`);
    dispatch({ type: ARTICLE_MARQUE_SUCCES, payload: data });
  } catch (error) {
    dispatch({ type: ARTICLE_MARQUE_ECHEC, payload: error });
  }
};

export const articleDetailsActions = (aId) => async (dispatch) => {
  try {
    dispatch({ type: ARTICLE_DETAILS_REQUETTE });
    const { data } = await Axios.get(`${uri}/api/articles/details/${aId}`);
    dispatch({ type: ARTICLE_DETAILS_SUCCES, payload: data });
  } catch (error) {
    dispatch({ type: ARTICLE_DETAILS_ECHEC, payload: error });
  }
};
export const ToutArticlesSearch = (search) => async (dispatch) => {
  dispatch({ type: ARTICLE_TOUT_RESET });
  try {
    const { data } = await Axios.get(`${uri}/api/articles/${search}`);

    dispatch({ type: ARTICLE_TOUT_SUCCES, payload: data });
  } catch (error) {
    dispatch({ type: ARTICLE_TOUT_ECHEC, payload: error });
  }
};

export const evaCreeAction = (evaluation, id) => async (dispatch) => {
  dispatch({ type: EVALUATION_REQUETTE });
  try {
    const config = {
      headers: {
        "content-type": "application/json",
      },
    };
    const { data } = await Axios.put(
      `${uri}/api/articles/evaluation/${id}`,
      evaluation,
      config
    );
    dispatch({ type: EVALUATION_SUCCES });
  } catch (error) {
    dispatch({ type: EVALUATION_ECHEC, payload: error.message });
  }
};

export const nvCreerArticle = (article) => async (dispatch, getState) => {
  try {
    dispatch({ type: ARTICLE_NV_CREE_REQUETTE });
    const {
      client: { client },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${client.token}`,
      },
    };

    const { data } = await Axios.post(
      `${uri}/api/articles/nv`,
      article,

      config
    );

    dispatch({ type: ARTICLE_NV_CREE_SUCCES, payload: data });
  } catch (error) {
    dispatch({
      type: ARTICLE_NV_CREE_ECHEC,
      payload: error.response && error.response.data.message,
    });
  }
};
